import styled, { css } from 'styled-components';

const InputHightlightCss = css`
  &:hover {
    border-color: #00ab6b;
  }

  &:focus {
    border-color: #00ab6b;
    border-right-width: 1px !important;
    outline: 0;

    box-shadow: 0 0 0 2px rgba(0, 171, 107, 0.2);
  }
`;

export const Input = styled.input<{ disableHighlight?: boolean }>`
  width: 100%;
  border: 1px solid #dadada;
  padding: 6px 12px;
  box-sizing: border-box;

  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #333333;

  border-radius: 2px;

  transition: 0.15s linear;
  transition-property: border-color, box-shadow;
  outline: 0;

  ${({ disableHighlight }) => !disableHighlight && InputHightlightCss}
`;
